import { ApiClient } from '@api/api-configuration';
import useNotifications from '@context/notifications/useNotificationContext';
import type { Dayjs } from 'dayjs';
import { useCallback } from 'react';
import type { EntityType } from './useCustomerProfile';

export interface ExportCustomerProfileParams {
  entityType: EntityType;
  entityId?: number;
  startAt?: Dayjs | null;
  endAt?: Dayjs | null;
}

export const useExportCustomerProfile = () => {
  const { openNotification } = useNotifications();

  const exportCustomerProfile = useCallback(
    async ({ entityType, entityId, startAt, endAt }: ExportCustomerProfileParams) => {
      try {
        await ApiClient.billingApi.billing.exportCustomerProfile({
          entityType,
          entityId: entityId ?? null,
          startAt: startAt ? startAt.startOf('day').toISOString() : null,
          endAt: endAt ? endAt.endOf('day').toISOString() : null,
        });
        openNotification('topRight', {
          type: 'Success',
          title: 'Export Started',
          description:
            'Customer profile export has been initiated. You will receive a notification when the export is ready for download.',
        });
      } catch {
        openNotification('topRight', {
          type: 'Warning',
          title: 'Export Failed',
          description: 'Failed to initiate customer profile export. Please try again.',
        });
      }
    },
    [openNotification]
  );

  return {
    exportCustomerProfile,
  };
};
